const Search = {
  aboveTheFoldImages: 6,
}

export default Search
